// Module
var code = `<div class="js-colorPicker" style="{{>visibility}}">
    <div class="js-colorPicker-header">
        <div class="js-colorPicker-cpCurrentColor-container">
            <div class="js-colorPicker-cpCurrentColor" style="background-color:{{.currentColor}};{{#.valueA===0}}background:url({{.noColorImage}}) center center no-repeat transparent; {{/}}" />
        </div>

        <terceraButton
                       terceraButtonStyle="js-button-remove-color"
                       image="{{.imageforRemoveBtn}}"
                       enabled="{{.valueA}}"
                       on-btnClick="removeColorClick" />

        <div class="js-colorPicker-labelNumeric">
            <terceraLabel text="R:" />
            <terceraNumeric additionalClass="colorPicker" value="{{.valueR}}" showArrows="false" on-keyUp="onRGBValueChange" minValue="0" maxValue="255" step="1" decimalPrecision="0" />
        </div>
        <div class="js-colorPicker-labelNumeric">
            <terceraLabel text="G:" />
            <terceraNumeric additionalClass="colorPicker" value="{{.valueG}}" showArrows="false" on-keyUp="onRGBValueChange" minValue="0" maxValue="255" step="1" decimalPrecision="0" />
        </div>
        <div class="js-colorPicker-labelNumeric">
            <terceraLabel text="B:" />
            <terceraNumeric additionalClass="colorPicker" value="{{.valueB}}" showArrows="false" on-keyUp="onRGBValueChange" minValue="0" maxValue="255" step="1" decimalPrecision="0" />
        </div>
    </div>

    <div class="js-colorPicker-body">
        <div class="js-colorPicker-cpMap" style="background-color:{{.mapColor}};" on-mousedown="onMapMouseDown" on-mouseup="onMapMouseUp" on-mousemove="onMapMouseMove" on-mouseenter="onMapMouseEnte" on-mouseleave="onMapMouseLeave">
            <div class="js-colorPicker-cpPoint {{.additionalStyle}}" style="top: {{.pointY}}px; left: {{.pointX}}px;" />
        </div>

        <div class="js-colorPicker-cpRainbowBar" on-mousedown="onRainbowBarMouseDown" on-mouseup="onRainbowBarMouseUp" on-mousemove="onRainbowBarMouseMove" on-mouseenter="onRainbowBarMouseEnte" on-mouseleave="onRainbowBarMouseLeave">
            <div class="js-colorPicker-cpRainbowSelector" style="top:{{.rainbowSelectorValue}}px;" />
        </div>
    </div>

    <div class="js-colorPicker-opacity-container">
        <div class="js-colorPicker-opacity" on-mousedown="onOpacityMouseDown" on-mouseup="onOpacityMouseUp" on-mousemove="onOpacityMouseMove" on-mouseenter="onOpacityMouseEnte" on-mouseleave="onOpacityMouseLeave">
            <div class="js-colorPicker-cpOpacitySelector" style="left:{{.pointA}}px;" />
        </div>
    </div>

</div>`;
// Exports
export default code;